import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { selectTruckingService } from 'store/reducers/customerQuotes/action';
import { TableCustomQuote } from 'components';
import { Box } from '@mui/material';
import ApiServices from 'services';
import { Columns } from './columns';
import { SUB_SERVICES_ID } from 'commons/constants';

function Truck() {
  const dispatch = useDispatch();
  const [truckList, setTruckList] = useState([]);
  const [loading, setLoading] = useState(false);

  const initData = async () => {
    setLoading(true);
    try {
      const { data } = await ApiServices.getDataQuotesTrucking(SUB_SERVICES_ID.TRUCK, {
        pageNumber: 1,
        pageSize: 10,
      });
      setTruckList(data?.data || []);
    } catch (err) {
      console.warn('initData - getDataQuotesTrucking', err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    initData();
  }, []);

  const handleSelectedChange = (row, values) => {
    dispatch(selectTruckingService(values));
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TableCustomQuote
        rows={truckList}
        headCells={Columns()}
        loading={loading}
        isHeader={false}
        isCheckbox={true}
        onSelectedChange={handleSelectedChange}
        checkedOnlyItem={true}
      />
    </Box>
  );
}
export { Truck };
